// 延迟加载优化脚本
(function() {
    'use strict';
    
    // 图片延迟加载
    function initLazyLoading() {
        if ('IntersectionObserver' in window) {
            const imageObserver = new IntersectionObserver((entries, observer) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        const img = entry.target;
                        if (img.dataset.src) {
                            img.src = img.dataset.src;
                            img.classList.remove('lazy');
                            img.classList.add('loaded');
                            observer.unobserve(img);
                        }
                    }
                });
            });

            document.querySelectorAll('img[data-src]').forEach(img => {
                imageObserver.observe(img);
            });
        } else {
            // 降级处理
            document.querySelectorAll('img[data-src]').forEach(img => {
                img.src = img.dataset.src;
                img.classList.remove('lazy');
                img.classList.add('loaded');
            });
        }
    }

    // 脚本延迟加载
    function loadScript(src, callback) {
        const script = document.createElement('script');
        script.src = src;
        script.async = true;
        if (callback) {
            script.onload = callback;
        }
        document.head.appendChild(script);
    }

     // 关键资源预加载
     function preloadCriticalResources() {
         const criticalResources = [
             '{{ "core.css" | asset_url }}',
             '{{ "header.css" | asset_url }}',
             '{{ "navigation-bar.css" | asset_url }}',
             '{{ "header-navigation.css" | asset_url }}',
             '{{ "main-nav.css" | asset_url }}'
         ];

        criticalResources.forEach(href => {
            const link = document.createElement('link');
            link.rel = 'preload';
            link.as = 'style';
            link.href = href;
            document.head.appendChild(link);
        });
    }

    // 非关键CSS延迟加载
    function loadNonCriticalCSS() {
        const nonCriticalCSS = [
            '{{ "article.css" | asset_url }}',
            '{{ "modal.css" | asset_url }}'
        ];

        nonCriticalCSS.forEach(href => {
            const link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = href;
            link.media = 'print';
            link.onload = function() {
                this.media = 'all';
            };
            document.head.appendChild(link);
        });
    }

    // 页面加载完成后初始化
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
            initLazyLoading();
            preloadCriticalResources();
            loadNonCriticalCSS();
        });
    } else {
        initLazyLoading();
        preloadCriticalResources();
        loadNonCriticalCSS();
    }

    // 窗口加载完成后加载非关键脚本
    window.addEventListener('load', function() {
        // 延迟加载非关键脚本
        setTimeout(() => {
            loadScript('{{ "modal.js" | asset_url }}');
            loadScript('{{ "drop-down.js" | asset_url }}');
        }, 1000);
    });

})();
